import React, { createContext, useContext, useMemo } from 'react';

import {
  createHttpClient,
  IHttpClient,
  useEnvironment,
} from '@wix/yoshi-flow-editor';
import { createClient, WixClient } from '@wix/sdk';

import { useMockClient } from '@/__tests__/HttpClientContext';

const HttpClientContext = createContext({
  get httpClient(): IHttpClient {
    throw new Error('httpClient is not provided');
  },
  get wixClient(): WixClient {
    throw new Error('wixClient is not provided');
  },
});

export const HttpClientProvider: React.FC<
  React.PropsWithChildren<{
    instance: string;
  }>
> = ({ instance, children }) => {
  const { isSSR } = useEnvironment();

  const mockClient = useMockClient();
  const httpClient = useMemo(
    () =>
      createHttpClient({
        isSSR,
        getAppToken: () => instance ?? '',
      }),
    [instance, isSSR],
  );
  const wixClient = useMemo(() => {
    return createClient({
      auth: {
        getAuthHeaders: async () => {
          return {
            headers: { Authorization: instance },
          };
        },
      },
    });
  }, [instance]);

  return (
    <HttpClientContext.Provider
      value={{
        httpClient: mockClient ?? httpClient,
        wixClient,
      }}
    >
      {children}
    </HttpClientContext.Provider>
  );
};

export const useHttpClient = () => useContext(HttpClientContext).httpClient;
export const useWixClient = () => useContext(HttpClientContext).wixClient;
